import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const TIMING = 16;

const heroStyles = {
  preloader: (): SystemStyleObject<Theme> => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    m: "auto",
    width: "10em",
    height: "10em",
    transformStyle: "preserve-3d",

    animation: `preloader-spin ${TIMING}s linear infinite`,
    "@keyframes preloader-spin": {
      from: {
        transform: "rotateY(0) rotateX(30deg)",
      },
      to: {
        transform: "rotateY(1turn) rotateX(30deg)",
      },
    },
  }),
  ring: (theme: Theme): SystemStyleObject<Theme> => ({
    transformStyle: "preserve-3d",
    animationName: "ring-spin",
    animationDuration: `${TIMING / 2}s`,
    animationTimingFunction: "inherit",
    animationIterationCount: "inherit",
    position: "relative",
    height: "3em",
    width: "1.5em",
    color: theme.palette.secondary.main,

    "&:nth-of-type(even)": {
      animationDirection: "reverse",
    },

    "@keyframes ring-spin": {
      from: {
        transform: "rotateY(0)",
      },
      to: {
        transform: "rotateY(1turn)",
      },
    },
  }),
  sector: (_, { index }: { index: number }): SystemStyleObject<Theme> => ({
    position: "absolute",
    top: 0,
    left: 0,
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: 600,
    fontSize: "2em",
    transform: `rotateY(${(360 / 30) * index - 1}deg) translateZ(3.5em)`,

    "&, &:empty:before": {
      display: "inline-block",
      width: "100%",
      height: "100%",
    },
    "&:empty:before": {
      backgroundImage:
        "linear-gradient(transparent 45%, currentColor 45% 55%, transparent 55%)",
      content: "''",
    },
  }),
};

export default heroStyles;
